import React from 'react';
import { motion } from 'framer-motion';
const visions = [{
  emoji: '😍',
  bold: 'Viendo a tu hijo pedir "la comida rica del otro día"',
  rest: ' sin saber que está comiendo súper sano',
  color: 'text-orange-600'
}, {
  emoji: '🍽️',
  bold: 'Cocinando una sola comida para toda la familia',
  rest: ' porque todos la van a comer felices',
  color: 'text-violet-600'
}, {
  emoji: '⚕️',
  bold: 'En el control pediátrico escuchando "siga así"',
  rest: ' cuando vean los análisis perfectos',
  color: 'text-emerald-600'
}, {
  emoji: '🏡',
  bold: 'Disfrutando las comidas familiares',
  rest: ' sin peleas, sin culpa, sin estrés',
  color: 'text-orange-500'
}, {
  emoji: '💪',
  bold: 'Sabiendo que tu hijo está creciendo sano y fuerte',
  rest: ' con todos los nutrientes que necesita',
  color: 'text-violet-500'
}];
const urgency = [{
  emoji: '❌',
  text: 'No esperes al próximo control con malas noticias',
  bold: false
}, {
  emoji: '❌',
  text: 'No dejes que desarrolle problemas de salud.',
  bold: false
}, {
  emoji: '✅',
  text: 'Dale la nutrición que se merece... de la forma que él va a amar',
  bold: true
}];
export function ImaginateSection() {
  return <section className="pt-10 pb-16 bg-gradient-to-br from-violet-600 via-violet-500 to-orange-500 relative overflow-hidden" data-id="element-167">
      {/* Decorative blobs */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-orange-400 rounded-full opacity-20 -translate-y-1/2 translate-x-1/3" data-id="element-168" />
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-emerald-400 rounded-full opacity-20 translate-y-1/2 -translate-x-1/4" data-id="element-169" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl relative z-10" data-id="element-170">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-extrabold text-white text-center mb-10" data-id="element-171">
          🌟 Imaginate dentro de 1 semana...
        </motion.h2>

        {/* Vision items */}
        <div className="flex flex-col gap-4 mb-10" data-id="element-172">
          {visions.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex items-start gap-3 bg-white/15 backdrop-blur-sm rounded-2xl px-5 py-4" data-id="element-173">
              <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-174">
                {item.emoji}
              </span>
              <p className="text-white text-base leading-relaxed" data-id="element-175">
                <strong className="font-extrabold" data-id="element-176">{item.bold}</strong>
                {item.rest}
              </p>
            </motion.div>)}
        </div>

        {/* Divider */}
        <div className="border-t border-white/30 mb-8" data-id="element-177" />

        {/* Urgency items */}
        <div className="flex flex-col gap-4" data-id="element-178">
          {urgency.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="flex items-start gap-3" data-id="element-179">
              <span className="text-2xl flex-shrink-0" data-id="element-180">{item.emoji}</span>
              <p className={`text-white text-base leading-relaxed ${item.bold ? 'font-extrabold text-lg' : ''}`} data-id="element-181">
                {item.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}